import React, { useEffect } from "react";
import { ApiCustomer } from "src/api/api_customer";
import { UUID } from "src/api/api_common";
import { GetSingleGroupResponse } from "src/api/generated/frontend_customer_v1";

/** Data provided by the {@link SINGLE_GROUP_CONTEXT} */
export type SingleGroupContext = {
    /** The currently available group */
    group: GetSingleGroupResponse;

    /** Reload the groups' information */
    reset: () => void;
};

/** {@link React.Context} to access the groups */
const SINGLE_GROUP_CONTEXT = React.createContext<SingleGroupContext>({
    group: {
        description: "",
        access_rules: {
            outbound: [],
            inbound: [],
        },
        name: "",
        uuid: "",
        external_id: "",
        internet: false,
        provider: "Ldap",
    },

    /**
     * Reset the group
     */
    reset: () => {},
});
SINGLE_GROUP_CONTEXT.displayName = "SingleGroup";
export default SINGLE_GROUP_CONTEXT;

/**
 * The properties for {@link SingleGroupProvider}
 */
export type SingleGroupProviderProps = {
    /**
     * The specific group
     */
    uuid: UUID;

    /**
     * Children of the provider
     */
    children: React.ReactNode;
};

/**
 * The provider of a tags context
 */
export function SingleGroupProvider(props: SingleGroupProviderProps) {
    const [group, setGroup] = React.useState<GetSingleGroupResponse | "loading">("loading");
    let fetching = false;

    /**
     * Fetch the groups
     */
    const fetchGroup = async () => {
        if (fetching) return;
        fetching = true;

        const res = await ApiCustomer.groups.getSingle(props.uuid);
        setGroup(res);

        fetching = false;
    };

    useEffect(() => {
        fetchGroup().then();
    }, [props.uuid]);

    if (group === "loading") {
        return <div>Loading ..</div>;
    }

    return (
        <SINGLE_GROUP_CONTEXT.Provider
            value={{
                group: group,
                reset: fetchGroup,
            }}
        >
            {props.children}
        </SINGLE_GROUP_CONTEXT.Provider>
    );
}
